<div class="wrapper">
  <span class="label" [ngClass]="code"></span>
  <span class="text">{{ text }}</span>
</div>
